import React, { memo } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { useSidePanelContext } from 'modules/rootPage';
import { ConnectorListTabs } from './ConnectorListTabs';
import ConnectorSyncStatusContextProvider from './contexts/ConnectorSyncStatusContextProvider';

type PageStyleProps = {
  pinned: boolean;
  isDocked: boolean;
};

/* eslint-disable indent */
const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 'unset',
    overflow: 'hidden',
    marginTop: 'unset',
    paddingLeft: ({ pinned, isDocked }: PageStyleProps) =>
      isDocked
        ? theme.spacing(0)
        : pinned
        ? theme.spacing(30)
        : theme.spacing(8),
    boxShadow: theme.shadow?.paper,
    backgroundColor: theme.palette.background.default,
    flexGrow: 1
  }
}));

export const ConnectorsPage: React.FC = memo(() => {
  const { pinned, isDocked } = useSidePanelContext();
  const classes = useStyles({
    pinned,
    isDocked
  });

  return (
    <ConnectorSyncStatusContextProvider>
      <div data-testid="connectors-page" className={classes.root}>
        <ConnectorListTabs />
      </div>
    </ConnectorSyncStatusContextProvider>
  );
});

ConnectorsPage.displayName = 'ConnectorsPage';
